

/**
 * Definition of a (hydra) collection as result type of API collection requests.
 * NOTE this is only a small part of the INativeHydraCollection interface that is
 * defined by the host application backend.
 */
export interface IHydraCollection<T> {
  "member"?: T[]
}

/**
 * Definition of an error body that is part of an error response.
 */
export interface HydraErrorBody {
  status: number
  title: string
  type: string
  detail?: string
}

/**
 * Content of the "title" element in 503 response body JSON
 * to distinguish "normal" 503 resonses from "maintenance" ones.
 */
export const MAINTENANCE_MODE_HYDRA_ERROR_TITLE = "Service Unavailable: System is in Maintenance Mode"